import Link from "next/link";

import { CardFooter } from "@/components/ui/card";

export function BackToSignInFooter() {
  return (
    <CardFooter className="p-0">
      <div className="w-full rounded-b-xl bg-muted/50 px-6 py-4 text-center text-sm text-muted-foreground">
        <Link
          href="/login"
          className="underline underline-offset-4 hover:text-primary"
        >
          Back to sign in
        </Link>
      </div>
    </CardFooter>
  );
}
